export default "__VITE_PUBLIC_ASSET__427a7c31__"